/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function() {


	var $win = jQuery(window),
		$body = jQuery('body');


	// Remove empty P tags created by WP inside of Accordion and Orbit
	jQuery('.accordion p:empty, .orbit p:empty').remove();

	// Adds Flex Video to YouTube and Vimeo Embeds
	jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
		  jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
		  jQuery(this).wrap("<div class='responsive-embed'/>");
		}
	});
	jQuery(window).on('load', function() {

		if ( jQuery('#main-nav .merch-link') ) {
			var merch_link = jQuery('#main-nav .merch-link a').attr("href");
			jQuery('.section-products .more-link a').attr("href", merch_link).attr("target", "_blank");
		} else {
			jQuery('.section-products .more-link a').hide();
		}

		
		if( $body.hasClass('home') ) {
			
			jQuery('.js-subscribe a').on('click', function(e) {
				// e.preventDefault();
	
				var $target = jQuery(this).attr('href');
	
				jQuery('html, body').animate({
					scrollTop: jQuery($target).offset().top
				}, 800);
	
				if ( jQuery(this).parents('.off-canvas') ) {
					jQuery('.js-off-canvas-overlay').trigger('click');
				}
	
			});
			// setTimeout(function(){ 
			// 	jQuery('.ae-cform-modal-display-cta').trigger('click');
			// }, 15000);

			jQuery("section.section").each(function(index) {
				var controller2 = new ScrollMagic.Controller();
				var currentEl2 = this;
	  
				var blockScene = new ScrollMagic.Scene({
					triggerElement: currentEl2,
					offset: 0,
					triggerHook: .6,
					reverse: false
				})
				.setClassToggle(currentEl2, 'animate-in')
				.addTo(controller2)
			});



			var $banner = jQuery('.js-banner'),
				$videos = jQuery('.js-video-list'),
				$products = jQuery('.js-products-list');
			
			$banner.slick({
				dots: true,
				fade: true,
				cssEase: 'linear',
				responsive: [
				  {
					breakpoint: 815,
					settings: {
						arrows: false
					}
				  }
				]
			});

            $banner.on('beforeChange', function(event, slick, currentSlide, nextSlide){
              $banner.addClass('is-sliding');
            });
      
            $banner.on('afterChange', function(event, slick, currentSlide){
              $banner.removeClass('is-sliding');
            });


			$videos.slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				initialSlide: 0,
				speed: 500,
				centerMode: false,
				cssEase: 'ease-in-out',
				useTransform: true,
				dots: false,
			});

			$products.slick({
				slidesToShow: 4,
				slidesToScroll: 1,
				initialSlide: 0,
				speed: 500,
				centerMode: false,
				cssEase: 'ease-in-out',
				useTransform: true,
				dots: false,
				responsive: [
				  {
					breakpoint: 1025,
					settings: {
						slidesToShow: 2
					}
				  },
				  {
					breakpoint: 601,
					settings: {
						slidesToShow: 1
					}
				  }
				]
			});

		} else {
			jQuery('.js-subscribe a').on('click', function(e) {
				e.preventDefault();
				if ( jQuery(this).parents('.off-canvas') ) {
					jQuery('.js-off-canvas-overlay').trigger('click');
				}
				jQuery('#ae-cform-modal-display-cta-2').trigger('click');
			});

		}


		var options = {
			valueNames: ['node-title', 'node-id'],
		};
		jQuery('.home .section-playlists').attr(
			'id',
			'playlist-list'
		);

		jQuery.each(
			jQuery('.home .section-playlists .type-playlist'),
			function() {
			var nodeID = jQuery(this).attr('id');
			jQuery(this).append('<div class="node-id">' + nodeID + '</div>');
			}
		);
		var musicList = new List('playlist-list', options);
	
		// // prevents sorting direction
		// $('.filter-newest').click(function () {
		//   musicList.sort('node-id', { order: 'asc' });
		// });
	
		function filterByCategory(category) {
			jQuery('article.type-playlist')
			.filter(function() {
				var playlistCategory = jQuery(this)
				.find('.playlist-category')
				.text();
				return playlistCategory.toUpperCase() === category.toUpperCase();
			})
			.show();
		}
	
		jQuery('.filter-container a').on('click', function(e) {
			e.preventDefault();
			jQuery('.filter-container a').removeClass('current');
			jQuery(this).addClass('current');
	
			jQuery(
			'.home .section-playlists .type-playlist'
			).removeClass('playlist-hidden');
			jQuery(
			'.home .section-playlists .custom-load-more'
			).hide();
	
			// Hide all list items
			jQuery(
			'.home .section-playlists .type-playlist'
			).hide();
	
			// Selected Category
			var category = jQuery(this).text();
			category.toUpperCase();
	
			// Filter and show list items
			setTimeout(filterByCategory(category), 300);
		});
	
		jQuery('.filter-container a.all-playlist').on('click', function(e) {
			e.preventDefault();
			jQuery('.filter-container a').removeClass('current');
			jQuery(this).addClass('current');
			jQuery('.type-playlist')
			.filter(function() {
				return true;
			})
			.show();
		})

		jQuery.each(
			jQuery('.home .section-playlists .type-playlist'),
			function(i, val) {
			  // Hide artist nodes after first 8
			  if (i > 7) {
				jQuery(this).addClass('playlist-hidden');
			  }
			}
		  );
		
		jQuery('.home .section-playlists .custom-load-more').on(
			'click',
			function(e) {
			  e.preventDefault();
			  jQuery(
				'.home .section-playlists .type-playlist'
			  ).removeClass('playlist-hidden');
			  jQuery(this).hide();
			}
		  );

		jQuery('.home .section-playlists .search').on(
			'input',
			function() {
				jQuery(
				'.home .section-playlists .custom-load-more'
			  ).trigger('click');
			}
		  );


		
	});
}); 